import type { ChatMessagesCache } from "@/sdk/agent/chat";

import { useChatStore } from "@/sdk";

/** Builds a stateless (non-reactive) ChatMessagesCache from the chat store's current getState(). */
export function getStatelessChatMessagesCache(): ChatMessagesCache {
    return {
        addChatMessages: useChatStore.getState().addChatMessages,
        removeChat: useChatStore.getState().removeChat,
        updateChatMessages: useChatStore.getState().updateChatMessages,
        markCustomerIsTyping: useChatStore.getState().markCustomerIsTyping,
        markCustomerStoppedTyping: useChatStore.getState().markCustomerStoppedTyping,
    };
}
